var tooltipComponent = Vue.component('tooltip-vue', {
  template: '#tooltip-vue',
  props: ['action', 'fixed']
});
